<template>
    <v-container fluid class="pa-0">
        <template v-if="loading">
            <v-overlay :value="loading">
                <v-progress-circular
                    :size="100"
                    color="white"
                    indeterminate
                ></v-progress-circular>
            </v-overlay>
        </template>
        <template v-else>
            <banner
                :title="$t('MyCalendarPageTitle')"
                :description="$t('MyCalendarPageDescription')"
            />
            <v-container>
                <calendar 
                    :calendarLoading="calendarLoading"
                    :timeslots.sync="timeslots" 
                    :tutorId="this.user.id" 
                    :editable="true"
                    :hasPrice="tutor.hasPrice"
                    @monthChange="getCalendar"
                />
            </v-container>
        </template>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner'
    import Calendar from '@/components/calendar'
 
    export default {
        name: 'myCalendar',
        data: () => ({
            tutor: {},
            timeslots: [],
            date: '',
            startTime: '',
            endTime: '', 
            addSessionFormVisibility: false,   
            loading: true,
            calendarLoading: true
        }),
        computed: {
            ...mapGetters(['user']),
        },
        components: {
            Calendar,
            Banner
        },
        mounted() {
            this.fetchTutor()
            this.$EventBus.$on('deleteTimeslot', this.deleteTimeslot)
            this.$EventBus.$on('updateTimeslots', this.updateTimeslots)
        },
        methods: {
            async fetchTutor() {
                let id = this.$route.params.id
                await this.axios.get('/Tutor/GetTutor', {
                    params: {
                        tutorId: this.user.id
                    }
                })
                .then(response => {
                    this.tutor = response.data.tutor
                    this.timeslots = response.data.timeslots
                    this.loading = false
                    this.calendarLoading = false
                })
                .catch(error => { console.log('Something went wrong: '+error) })
            },
            deleteTimeslot(session) {
                let formatDate = moment(session.date).format('YYYY-MM-DD')
                this.getCalendar(formatDate)

                const snackbar = {
                    show: true,
                    message: this.$i18n.t('SessionDeletedNotification')
                }
                this.$EventBus.$emit('snackbar', snackbar)
            },
            updateTimeslots(date) {
                let formatDate = moment(date.replace(/-/g, '/')).format('YYYY-MM-DD')
                this.getCalendar(formatDate)
            },
            changeHandler(event) {
                let startTime = new Date()
            },
            async getCalendar(date) {
                this.calendarLoading = true
                await this.axios.get('/Calendar/GetCalendarByTutor', {
                    params: {
                        tutorId: this.user.id,
                        date: date
                    }
                })
                .then(response => {
                    this.timeslots = response.data.timeslots
                    this.calendarLoading = false
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.calendarLoading = false
                })
            }
        }
    }
</script>

<style lang="scss" scoped></style>